import React, { useState, useMemo, MouseEvent } from 'react';
import {
  Link,
  Section,
  SectionSubTitle,
  SelectionGroup,
  SelectionGroupOption,
  SelectionGroupValue,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import {
  CATEGORIES_MAP,
  CATEGORIES_TAB_LIST,
  CategoriesTabName,
  CategoryStructure,
} from './categories-section-constants';
import {
  categoriesGridStylesMap,
  categoriesSectionItem,
  categoriesSectionItemImage,
  categoriesSectionItemImageWrapper,
  categoriesSectionItemName,
  categoriesSectionTabs,
  StyledCategoriesGrid,
} from './categories-section-styles';

type CategoriesSectionProps = {
  elementBlock: string;
}

export const CategoriesSection: React.FC<CategoriesSectionProps> = ({ elementBlock }) => {
  const [activeCategory, setActiveCategory] = useState(CategoriesTabName.BuiltInAppliances);

  const newKitchenCategoriesList = useMemo(() => CATEGORIES_MAP[activeCategory], [
    activeCategory,
  ]);

  const handleCategoryTabChange = (_: MouseEvent, value: SelectionGroupValue) => {
    setActiveCategory(value as CategoriesTabName);

    const activeCategoryTabName: SelectionGroupOption | undefined = CATEGORIES_TAB_LIST.find(
      (option: SelectionGroupOption) => option.value === value
    );

    if (activeCategoryTabName) {
      analyticsUtils.clickButtonEvent(
        elementBlock,
        activeCategoryTabName.text,
        'Всё для удобной и стильной кухни'
      );
    }
  };

  const handleCategoryClick = (clickedItem: CategoryStructure) => () => {
    analyticsUtils.clickButtonEvent(
      elementBlock,
      clickedItem.name,
      'Всё для удобной и стильной кухни'
    );
  };

  const handleCategoryWheelClick = (clickedItem: CategoryStructure) => (e: MouseEvent) => {
    if (e.button === 1) {
      handleCategoryClick(clickedItem)();
    }
  };

  return (
    <Section>
      <SectionSubTitle margin="m">Всё для удобной и&nbsp;стильной кухни</SectionSubTitle>
      <SelectionGroup
        className={categoriesSectionTabs}
        noSwipingWidth={1024}
        active={activeCategory}
        onChange={handleCategoryTabChange}
        optionList={CATEGORIES_TAB_LIST}
        rounded
      />
      <StyledCategoriesGrid
        categoriesNumber={newKitchenCategoriesList.length}
        className={categoriesGridStylesMap[newKitchenCategoriesList.length]}>
        {newKitchenCategoriesList.map((category, index) => (
          <li key={createElementKey('kitchen-category', index)}>
            <Link
              onClick={handleCategoryClick(category)}
              onAuxClick={handleCategoryWheelClick(category)}
              className={categoriesSectionItem}
              title={category.name}
              href={category.href}>
              <div className={categoriesSectionItemImageWrapper}>
                <img
                  className={categoriesSectionItemImage}
                  src={category.image}
                  alt={category.name}
                  width="80"
                  height="80"
                  loading="lazy"
                />
              </div>
              <Typography className={categoriesSectionItemName} variant="s" size="body_long">
                {category.name}
              </Typography>
            </Link>
          </li>
        ))}
      </StyledCategoriesGrid>
    </Section>
  );
};
